// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1yhI6","approved":"Status_approved__1fk48","rejected":"Status_rejected__20Npq","expired":"Status_expired__3NpxG","label":"Status_label__31ysn"};